import * as React from "react"
import { Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"


export default function dateColumn() {
	return {
		name: "date",
		setBodyCellProps: () => ({ sx: { textAlign: 'center'} }),
		render: value => <Typography variant="caption">
            {formatDate(value, {isString: true})}
        </Typography>
	}
}